var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdownNav(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5205 8.76745C12.1449 8.76745 11.9646 9.2285 12.2406 9.48327L13.9062 11.0207C14.0642 11.1666 14.3079 11.1666 14.4659 11.0207L16.1315 9.48327C16.4075 9.2285 16.2273 8.76745 15.8516 8.76745H12.5205Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 7.75083C1 6.23159 2.23159 5 3.75083 5H16.2492C17.7684 5 19 6.23159 19 7.75083V11.8771C19 13.3963 17.7684 14.6279 16.2492 14.6279H3.75083C2.23159 14.6279 1 13.3963 1 11.8771V7.75083ZM2.37542 7.75083C2.37542 6.99121 2.99121 6.37542 3.75083 6.37542H16.2492C17.0088 6.37542 17.6246 6.99121 17.6246 7.75083V11.8771C17.6246 12.6367 17.0088 13.2525 16.2492 13.2525H3.75083C2.99121 13.2525 2.37542 12.6367 2.37542 11.8771V7.75083Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdownNav);
export default __webpack_public_path__ + "static/media/dropdown-nav.89f936d9.svg";
export { ForwardRef as ReactComponent };